(() => {
  'use strict';
    
    // Prevent multiple initializations
    if (window.upsellHandlerInitialized) {
      return;
    }
    window.upsellHandlerInitialized = true;

    // -- tiny helpers
    const q = (s, r=document) => r.querySelector(s);
    const qa = (s, r=document) => Array.from(r.querySelectorAll(s));

    function getUpsellCard(ctx=document) { return q('section[data-upsell-id]', ctx); }
    function getProductFormForCard(card) {
      const pf = card.closest('product-form');
      return pf ? q('form[action*="/cart/add"]', pf) : null;
    }
    function getMainForm() {
      const card = getUpsellCard();
      if (card) {
        const f = getProductFormForCard(card);
        if (f) return f;
      }
      return q('.main-product__info form[action*="/cart/add"]') || q('.floating-atc form[action*="/cart/add"]');
    }
    function getQty(form) {
      const el = form.querySelector('input[name="quantity"], input[name="qty"]');
      const v = parseInt(el && el.value, 10);
      return Number.isFinite(v) && v > 0 ? v : 1;
    }
    function getMainVariantId(form) {
      const el = form.querySelector('[name="id"]');
      return el && el.value;
    }

    // ---- Upsell helpers
    const isUpsellOn = (card) => card && card.getAttribute('data-enabled') === 'on';
    function selectedUpsellValue(card) {
      const uid = card.getAttribute('data-upsell-id');

      // NEW: prefer hidden selected variant ID (set by snippet)
      const hidden = card.querySelector('.upsell-selected-variant');
      if (hidden && hidden.value) {
        return hidden.value;
      }

      // Fallback for older single-option implementation
      const r = card.querySelector('input[type="radio"][name="bracelet_length_' + uid + '"]:checked');
      return r ? r.value : null;
    }

    function getUpsellVariants(card) {
      const uid = card.getAttribute('data-upsell-id');
      const node = document.getElementById('upsell-' + uid + '-variants');
      if (!node) return [];
      try { return JSON.parse(node.textContent || '[]'); } catch { return []; }
    }
    function resolveVariantId(card, chosen) {
      if (!card || !chosen) return null;
      const variants = getUpsellVariants(card);

      // NEW: if chosen value is already a variant ID, use it directly
      const direct = variants.find(v => String(v.id) === String(chosen));
      if (direct) return direct.id;

      // Legacy fallback logic (for older single-option setups)
      const idx = parseInt(card.getAttribute('data-option-index'), 10); // 0..2 or NaN

      if (Number.isInteger(idx) && idx >= 0) {
        const key = 'option' + (idx + 1);
        const found = variants.find(v => (v[key] || '').trim() === chosen.trim());
        if (found) return found.id;
      }
      for (const v of variants) {
        if ((v.option1 && v.option1.trim() === chosen.trim()) ||
            (v.option2 && v.option2.trim() === chosen.trim()) ||
            (v.option3 && v.option3.trim() === chosen.trim())) return v.id;
      }
      const norm = s => (s || '').replace(/\s{2,}/g, ' ').trim();
      const chosenNorm = norm(chosen);
      for (const v of variants) if (norm(v.title).includes(chosenNorm)) return v.id;
      return null;
    }

    // ---- Drawer helpers
    function openCartDrawer() {
      const drawer = document.querySelector('cart-drawer, #CartDrawer');
      if (drawer) {
        if (typeof drawer.open === 'function') { drawer.open(); return; }
        try { drawer.setAttribute('open', ''); } catch {}
      }
      document.documentElement.classList.add('cart-drawer-open','is-cart-open','js-drawer-open-cart');
      const togglers = document.querySelectorAll(
        '[data-cart-drawer-toggle], [data-drawer-toggle="cart"], [data-action="open-drawer"][data-drawer="cart"], .js-drawer-open-cart, button[name="open-drawer"][value="cart"], a[href="/cart"].header__icon'
      );
      for (const t of togglers) t.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      window.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('cart:open'));
    }

    async function addItems(items) {
      // Use the theme's existing addToCart function if available
      if (typeof window.addToCart === 'function') {
        console.log('[Upsell] Using theme\'s addToCart function');
        window.addToCart(items);
        return Promise.resolve({ items });
      }
      
      // Fallback to direct fetch
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error(await res.text().catch(()=> 'Add failed'));
      return res.json();
    }

    async function fetchCartJson() {
      try {
        const r = await fetch('/cart.js', { 
          headers: { 'Accept': 'application/json' }, 
          cache: 'no-store' 
        });
        if (!r.ok) throw new Error('cart.js not ok');
        return await r.json();
      } catch (e) {
        console.warn('[Upsell] /cart.js failed', e);
        return null;
      }
    }

    // Simplified approach: work with theme's existing cart system
    async function refreshCartDrawer(addedItems = []) {
      try {
        console.log('[Upsell] Starting cart refresh using theme methods...');
        
        // Give the server time to process the add request
        await new Promise(resolve => setTimeout(resolve, 600));
        
        // Get fresh cart data
        const cart = await fetchCartJson();
        if (!cart) {
          console.warn('[Upsell] Could not fetch cart data');
          return false;
        }
        
        console.log('[Upsell] Cart data retrieved, item count:', cart.item_count);
        console.log('[Upsell] Cart items:', cart.items?.map(i => i.product_title || i.title) || 'No items array');

        // Strategy 1: Use your theme's existing cart refresh system
        const cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement && typeof window.changeItemQuantity === 'function') {
          console.log('[Upsell] Using theme\'s cart refresh system');
          
          // Trigger a dummy cart change to refresh the drawer
          // This will use your theme's existing refresh logic
          const firstItem = cart.items[0];
          if (firstItem) {
            // Change quantity to same value to trigger refresh without actually changing anything
            await window.changeItemQuantity(firstItem.key, firstItem.quantity);
            return true;
          }
        }
        
        // Strategy 2: Use theme's cart drawer render method
        if (cartDrawerElement && cartDrawerElement.render) {
          console.log('[Upsell] Using CartDrawer render method');
          
          // Fetch cart sections using your theme's method
          const sectionsToRender = cartDrawerElement.getSectionsToRender();
          const sectionIds = sectionsToRender.map(section => section.id);
          
          const formData = new FormData();
          formData.append('sections', sectionIds.join(','));
          
          const response = await fetch('/cart/add.js', {
            method: 'POST', 
            body: formData
          });
          
          if (response.ok) {
            const data = await response.json();
            if (data.sections && data.sections['cart-drawer']) {
              cartDrawerElement.render(data.sections['cart-drawer'], 'cart-drawer');
              return true;
            }
          }
        }
        
        // Strategy 3: Force a complete page reload of cart drawer (nuclear option)
        console.log('[Upsell] Using nuclear refresh option...');
        return await forceThemeCartRefresh();
        
      } catch (e) {
        console.error('[Upsell] Cart refresh failed:', e);
        return false;
      }
    }

    // Force refresh using theme's expected method
    async function forceThemeCartRefresh() {
      try {
        const cartDrawerElement = document.querySelector('cart-drawer');
        if (!cartDrawerElement) return false;
        
        // Method 1: Use theme's own section fetching
        const sectionsData = await fetch('/cart.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            sections: ['cart-drawer']
          })
        });
        
        if (sectionsData.ok) {
          const data = await sectionsData.json();
          if (data.sections && data.sections['cart-drawer']) {
            console.log('[Upsell] Rendering with theme method');
            cartDrawerElement.render(data.sections['cart-drawer'], 'cart-drawer');
            return true;
          }
        }
        
        // Method 2: Trigger your addToCart function with empty array to refresh
        if (typeof window.addToCart === 'function') {
          console.log('[Upsell] Triggering theme addToCart refresh');
          window.addToCart([]); // Empty array should just refresh
          return true;
        }
        
        return false;
      } catch (e) {
        console.error('[Upsell] Force theme refresh failed:', e);
        return false;
      }
    }

    // Try to reinitialize the theme's cart drawer properly
    async function reinitializeThemeCartDrawer() {
      try {
        console.log('[Upsell] Attempting to reinitialize theme cart drawer...');
        
        // Wait for DOM to be fully ready
        await new Promise(resolve => setTimeout(resolve, 300));
        
        // Check if the cart drawer element exists and has the expected structure
        const drawerElement = document.querySelector('cart-drawer');
        if (drawerElement) {
          console.log('[Upsell] Found cart-drawer element');
          
          // Check if the required upsells container exists
          const upsellsContainer = drawerElement.querySelector('.cd-upsells');
          if (!upsellsContainer) {
            console.warn('[Upsell] Missing .cd-upsells container, cart drawer may not render properly');
            return;
          }
          
          // Try to safely reinitialize the CartDrawer
          try {
            // Prevent the populateUpsells error by temporarily catching it
            const originalError = window.onerror;
            let errorCaught = false;
            
            window.onerror = function(message, source, lineno, colno, error) {
              if (message.includes('Cannot set properties of null') || 
                  message.includes('populateUpsells')) {
                console.warn('[Upsell] Caught theme cart drawer error, continuing...', message);
                errorCaught = true;
                return true; // Prevent the error from breaking execution
              }
              return originalError ? originalError.apply(this, arguments) : false;
            };
            
            // Wait a bit more for theme initialization
            await new Promise(resolve => setTimeout(resolve, 200));
            
            // Try to manually trigger the cart drawer's initialization methods
            if (drawerElement.init && typeof drawerElement.init === 'function') {
              drawerElement.init();
            }
            
            // Restore original error handler after a delay
            setTimeout(() => {
              window.onerror = originalError;
            }, 1000);
            
          } catch (e) {
            console.log('[Upsell] Theme reinitialization had errors (this is expected):', e.message);
          }
          
          // Try to manually populate the upsells container if it's empty
          const upsellsContent = upsellsContainer.innerHTML.trim();
          if (!upsellsContent || upsellsContent === '') {
            console.log('[Upsell] Upsells container is empty, attempting manual population...');
            
            // Get the most recent item for recommendations
            const cartItems = document.querySelectorAll('.cart-drawer__item');
            let mostRecentItemId = '8688404627780'; // fallback
            
            if (cartItems.length > 0) {
              const firstItem = cartItems[0];
              const itemData = firstItem.dataset;
              if (itemData && itemData.productId) {
                mostRecentItemId = itemData.productId;
              }
            }
            
            // Manually fetch recommendations
            try {
              const recommendationsUrl = `${window.Shopify.routes.root}recommendations/products?product_id=${mostRecentItemId}&limit=4&section_id=cart-drawer-recommendations&intent=related`;
              const response = await fetch(recommendationsUrl);
              
              if (response.ok) {
                const html = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const recommendationsContent = doc.querySelector('.cd-upsells');
                
                if (recommendationsContent) {
                  upsellsContainer.innerHTML = recommendationsContent.innerHTML;
                  console.log('[Upsell] Successfully populated upsells manually');
                }
              }
            } catch (e) {
              console.warn('[Upsell] Manual upsells population failed:', e);
            }
          }
        }
        
        // Try dispatching theme-specific initialization events
        const initEvents = [
          'theme:cart:init',
          'cart:drawer:init', 
          'shopify:cart:init',
          'drawer:loaded'
        ];
        
        initEvents.forEach(eventName => {
          document.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
          window.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
        });
        
        
      } catch (e) {
        console.warn('[Upsell] Theme reinitialization failed:', e);
      }
    }

    // Nuclear option: completely reload the drawer
    async function forceDrawerReload(cart) {
      try {
        const drawerSelectors = [
          'cart-drawer',
          '#CartDrawer',
          '.cart-drawer',
          '[data-section-type="cart-drawer"]',
          '.drawer--cart'
        ];
        
        let drawerElement = null;
        for (const selector of drawerSelectors) {
          drawerElement = document.querySelector(selector);
          if (drawerElement) break;
        }
        
        if (!drawerElement) {
          console.warn('[Upsell] No cart drawer element found for nuclear reload');
          return false;
        }
        
        console.log('[Upsell] Found drawer element:', drawerElement.tagName, drawerElement.className);
        
        // Method 1: Try to find and call a refresh method on the drawer element
        if (typeof drawerElement.refresh === 'function') {
          console.log('[Upsell] Calling drawer.refresh()');
          drawerElement.refresh();
          return true;
        }
        
        // Method 2: Try to trigger a re-render by removing and re-adding
        const parent = drawerElement.parentNode;
        const nextSibling = drawerElement.nextSibling;
        const drawerHTML = drawerElement.outerHTML;
        
        // Remove the drawer
        parent.removeChild(drawerElement);
        
        // Fetch fresh cart page
        const response = await fetch('/cart', {
          headers: { 'Accept': 'text/html' },
          cache: 'no-store'
        });
        
        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Find the fresh drawer
          let freshDrawer = null;
          for (const selector of drawerSelectors) {
            freshDrawer = doc.querySelector(selector);
            if (freshDrawer) break;
          }
          
          if (freshDrawer) {
            console.log('[Upsell] Inserting fresh drawer element');
            parent.insertBefore(freshDrawer, nextSibling);
            return true;
          } else {
            // Fallback: restore original drawer
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = drawerHTML;
            const restoredDrawer = tempDiv.firstElementChild;
            parent.insertBefore(restoredDrawer, nextSibling);
            console.warn('[Upsell] Could not find fresh drawer, restored original');
          }
        }
        
        return false;
      } catch (e) {
        console.error('[Upsell] Nuclear drawer reload failed:', e);
        return false;
      }
    }

    async function refreshCartSections(cart) {
      // Find all possible cart section IDs and selectors
      const possibleSelectors = [
        '#CartDrawer',
        'cart-drawer',
        '[data-section-id*="cart"]',
        '.cart-drawer',
        '#cart-drawer',
        '.drawer--cart',
        '#shopify-section-cart-drawer',
        '.shopify-section[data-section-type="cart-drawer"]'
      ];
      
      const sectionIds = new Set(['cart-drawer', 'cart-icon-bubble']);
      
      // Find actual section IDs from DOM
      possibleSelectors.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
          if (el.dataset && el.dataset.sectionId) {
            sectionIds.add(el.dataset.sectionId);
          }
          // Also check if the element has an ID that contains 'section'
          if (el.id && el.id.includes('shopify-section-')) {
            const sectionId = el.id.replace('shopify-section-', '');
            sectionIds.add(sectionId);
          }
        }
      });

      console.log('[Upsell] Refreshing sections:', Array.from(sectionIds));

      let refreshSuccess = false;

      // Strategy 1: Try to refresh each section individually
      for (const sectionId of sectionIds) {
        try {
          const timestamp = Date.now();
          const url = `/cart?section_id=${encodeURIComponent(sectionId)}&_=${timestamp}`;
          
          console.log('[Upsell] Fetching section:', sectionId, 'from:', url);
          
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Accept': 'text/html',
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              'Pragma': 'no-cache',
              'Expires': '0'
            },
            cache: 'no-store'
          });

          if (response.ok) {
            const html = await response.text();
            console.log('[Upsell] Section HTML received for:', sectionId, 'length:', html.length);
            
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Try multiple ways to find the section content
            const possibleNewSections = [
              doc.getElementById(`shopify-section-${sectionId}`),
              doc.querySelector(`[data-section-id="${sectionId}"]`),
              doc.querySelector(`#shopify-section-${sectionId}`),
              doc.body.firstElementChild,
              doc.querySelector('cart-drawer'),
              doc.querySelector('#CartDrawer')
            ].filter(Boolean);

            // Try multiple ways to find the current section
            const possibleCurrentSections = [
              document.getElementById(`shopify-section-${sectionId}`),
              document.querySelector(`[data-section-id="${sectionId}"]`),
              document.querySelector(`#shopify-section-${sectionId}`),
              document.querySelector('cart-drawer'),
              document.querySelector('#CartDrawer')
            ].filter(Boolean);

            for (const newSection of possibleNewSections) {
              for (const currentSection of possibleCurrentSections) {
                if (newSection && currentSection) {
                  console.log('[Upsell] Replacing section content for:', sectionId);
                  currentSection.innerHTML = newSection.innerHTML;
                  refreshSuccess = true;
                  
                  // Trigger any initialization scripts
                  const scripts = currentSection.querySelectorAll('script');
                  scripts.forEach(script => {
                    if (script.src) return; // Skip external scripts
                    try {
                      eval(script.innerHTML);
                    } catch (e) {
                      console.warn('[Upsell] Script execution failed:', e);
                    }
                  });
                  break;
                }
              }
              if (refreshSuccess) break;
            }
          } else {
            console.warn('[Upsell] Section fetch failed:', response.status, response.statusText);
          }
        } catch (error) {
          console.warn('[Upsell] Section refresh failed for', sectionId, error);
        }
      }

      // Strategy 2: If section refresh didn't work, try direct cart page fetch
      if (!refreshSuccess) {
        try {
          console.log('[Upsell] Section refresh failed, trying full cart page refresh...');
          const response = await fetch('/cart', {
            headers: { 'Accept': 'text/html' },
            cache: 'no-store'
          });
          
          if (response.ok) {
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Find cart drawer in the full page
            const newDrawer = doc.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-section-type="cart-drawer"]');
            const currentDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-section-type="cart-drawer"]');
            
            if (newDrawer && currentDrawer) {
              console.log('[Upsell] Replacing entire cart drawer from full page');
              currentDrawer.innerHTML = newDrawer.innerHTML;
              refreshSuccess = true;
            }
          }
        } catch (error) {
          console.error('[Upsell] Full cart page refresh failed:', error);
        }
      }

      return refreshSuccess;
    }

    async function triggerThemeCartRefresh(cart) {
      let refreshSuccess = false;
      
      // Try various theme-specific refresh methods
      const refreshMethods = [
        {
          name: 'window.CartDrawer.renderContents',
          method: () => window.CartDrawer && window.CartDrawer.renderContents && window.CartDrawer.renderContents(cart)
        },
        {
          name: 'window.theme.cart.render',
          method: () => window.theme && window.theme.cart && window.theme.cart.render && window.theme.cart.render(cart)
        },
        {
          name: 'window.cart.refresh',
          method: () => window.cart && window.cart.refresh && window.cart.refresh()
        },
        {
          name: 'window.Shopify.theme.cart.refresh',
          method: () => window.Shopify && window.Shopify.theme && window.Shopify.theme.cart && window.Shopify.theme.cart.refresh && window.Shopify.theme.cart.refresh()
        },
        {
          name: 'window.drawer.refresh',
          method: () => window.drawer && window.drawer.refresh && window.drawer.refresh()
        },
        {
          name: 'CartDrawer.open',
          method: () => window.CartDrawer && window.CartDrawer.open && window.CartDrawer.open()
        },
        {
          name: 'cart-drawer.renderContents',
          method: () => {
            const drawer = document.querySelector('cart-drawer');
            return drawer && drawer.renderContents && drawer.renderContents(cart);
          }
        },
        {
          name: 'cart-drawer.refresh',
          method: () => {
            const drawer = document.querySelector('cart-drawer');
            return drawer && drawer.refresh && drawer.refresh();
          }
        }
      ];

      for (const refreshMethod of refreshMethods) {
        try {
          console.log('[Upsell] Trying theme method:', refreshMethod.name);
          const result = await refreshMethod.method();
          if (result !== false && result !== undefined) {
            console.log('[Upsell] Theme refresh method succeeded:', refreshMethod.name);
            refreshSuccess = true;
            break; // Exit on first success
          }
        } catch (e) {
          console.log('[Upsell] Theme method failed:', refreshMethod.name, e.message);
        }
      }
      
      return refreshSuccess;
    }

    async function dispatchCartEvents(cart, addedItems) {
      const eventDetail = { 
        cart, 
        items: addedItems, 
        source: 'upsell',
        cartData: cart
      };
      
      // Comprehensive list of cart-related events
      const events = [
        'cart:refresh',
        'cart:updated',
        'cart:change', 
        'cart:render',
        'cart:rendered',
        'ajaxProduct:added',
        'cart:request:complete',
        'drawer:refresh',
        'shopify:cart:updated'
      ];

      // Dispatch on both document and window with slight delays
      for (let i = 0; i < events.length; i++) {
        const eventName = events[i];
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent(eventName, { 
            detail: eventDetail, 
            bubbles: true, 
            cancelable: true 
          }));
          window.dispatchEvent(new CustomEvent(eventName, { 
            detail: eventDetail, 
            bubbles: true, 
            cancelable: true 
          }));
        }, i * 50); // Stagger events by 50ms
      }
    }

    // Polling to ensure cart syncs properly with enhanced fallback
    async function waitForCartSync(expectedCount, maxAttempts = 12, delayMs = 250) {
      console.log('[Upsell] Starting cart sync polling, expecting count:', expectedCount);
      
      for (let i = 0; i < maxAttempts; i++) {
        const cart = await fetchCartJson();
        console.log('[Upsell] Poll attempt', i + 1, 'cart count:', cart?.item_count || 0);
        
        if (cart && cart.item_count >= expectedCount) {
          console.log('[Upsell] Cart sync achieved, doing final refresh...');
          
          // Do one final comprehensive refresh
          await refreshCartSections(cart);
          await triggerThemeCartRefresh(cart);
          await dispatchCartEvents(cart, cart.items);
          
          return true;
        }
        await new Promise(resolve => setTimeout(resolve, delayMs));
      }
      
      console.warn('[Upsell] Cart sync polling completed without reaching expected count');
      
      // Final fallback: force a page reload of cart drawer content
      try {
        const drawerElement = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
        if (drawerElement) {
          // Force reload by temporarily removing and re-adding
          const parent = drawerElement.parentNode;
          const nextSibling = drawerElement.nextSibling;
          parent.removeChild(drawerElement);
          
          // Fetch fresh cart drawer HTML
          const response = await fetch('/cart', {
            headers: { 'Accept': 'text/html' }
          });
          
          if (response.ok) {
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const freshDrawer = doc.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
            
            if (freshDrawer) {
              parent.insertBefore(freshDrawer, nextSibling);
              console.log('[Upsell] Force-reloaded cart drawer');
            }
          }
        }
      } catch (e) {
        console.error('[Upsell] Final fallback failed:', e);
      }
      
      return false;
    }

    function initToggleState() {
      const cards = qa('section[data-upsell-id]');
      cards.forEach(card => {
        const toggleInput = card.querySelector('.mb-toggle input[type="checkbox"]');
        const toggleContainer = card.querySelector('.mb-toggle');
        
        if (!toggleInput || !toggleContainer) return;
        
        console.log('[Upsell] Initializing toggle for card:', card.getAttribute('data-upsell-id'));
        
        // Clean up existing handlers
        if (toggleInput._upsellHandler) {
          toggleInput.removeEventListener('change', toggleInput._upsellHandler);
        }
        if (toggleContainer._upsellContainerHandler) {
          toggleContainer.removeEventListener('click', toggleContainer._upsellContainerHandler);
        }
        
        // Function to update radio button states
        const updateRadioStates = () => {
          const isOn = toggleInput.checked;
          card.setAttribute('data-enabled', isOn ? 'on' : 'off');
          
          const radios = card.querySelectorAll('input[type="radio"]');
          radios.forEach(radio => {
            radio.disabled = !isOn;
          });
          
          console.log('[Upsell] Toggle state updated to:', isOn ? 'ON' : 'OFF');
        };
        
        // Primary toggle handler
        const toggleHandler = (e) => {
          console.log('[Upsell] Toggle handler triggered, checked:', e.target.checked);
          e.stopPropagation();
          updateRadioStates();
        };
        
        // Container click handler for toggle only
        const containerClickHandler = (e) => {
          if (e.target === toggleContainer || 
              e.target.classList.contains('track') || 
              e.target.classList.contains('knob') ||
              e.target.classList.contains('state')) {
            
            e.preventDefault();
            e.stopPropagation();
            
            toggleInput.checked = !toggleInput.checked;
            console.log('[Upsell] Manual toggle to:', toggleInput.checked ? 'ON' : 'OFF');
            
            toggleInput.dispatchEvent(new Event('change', { bubbles: false }));
          }
        };
        
        // Attach toggle handlers
        toggleInput._upsellHandler = toggleHandler;
        toggleContainer._upsellContainerHandler = containerClickHandler;
        
        toggleInput.addEventListener('change', toggleHandler);
        toggleContainer.addEventListener('click', containerClickHandler);
        
        // Simple radio button handling - let them work naturally
        const radioButtons = card.querySelectorAll('input[type="radio"]');
        radioButtons.forEach((radio) => {
          if (radio._upsellRadioHandler) {
            radio.removeEventListener('change', radio._upsellRadioHandler);
          }
          
          const radioHandler = (e) => {
            console.log('[Upsell] Radio button changed to:', e.target.value);
          };
          
          radio._upsellRadioHandler = radioHandler;
          radio.addEventListener('change', radioHandler);
        });
        
        // Prevent card background clicks from interfering with radio selection
        // Only target the main card background areas, not interactive elements
        const cardBackgroundAreas = [
          card.querySelector('.mb-hd'),
          card.querySelector('.mb-body'),
          card.querySelector('.mb-content'),
          card.querySelector('.mb-save'),
          card.querySelector('.mb-copy')
        ].filter(Boolean);

        
        cardBackgroundAreas.forEach(area => {
          if (area._backgroundHandler) {
            area.removeEventListener('click', area._backgroundHandler);
          }
          
          const backgroundHandler = (e) => {
            // Only prevent if the click is directly on the background element
            // and not on any child interactive elements
            if (e.target === area && 
                !e.target.closest('.mb-sizes-wrap') && 
                !e.target.closest('.mb-toggle')) {
              
              e.preventDefault();
              e.stopPropagation();
              console.log('[Upsell] Prevented background area click');
            }
          };
          
          area._backgroundHandler = backgroundHandler;
          area.addEventListener('click', backgroundHandler);
        });
        
        // Set initial state
        updateRadioStates();
        
        console.log('[Upsell] Simple toggle initialization complete for card:', card.getAttribute('data-upsell-id'));
      });
    }

    function bindUpsellLogic() {
      const card = getUpsellCard();
      if (!card) return;

      // Initialize toggle states first
      initToggleState();

      const forms = [getMainForm(), q('.floating-atc form[action*="/cart/add"]')].filter(Boolean);
      
      forms.forEach(form => {
        if (form._upsellBound) return; // Already bound
        
        const addBtn = form.querySelector('[type="submit"][name="add"], button[name="add"], .product-form__submit, button[type="submit"]');

        const handler = async (evt) => {
          if (!isUpsellOn(card)) {
            console.log('[Upsell] Toggle OFF - using default cart flow');
            return; // Let default theme handle it
          }

          console.log('[Upsell] Toggle ON - using upsell flow');
          evt.preventDefault();
          evt.stopPropagation();

          // Guard against the click+submit double-binding (and impatient
          // repeat clicks) firing more than one /cart/add.js request.
          if (form.__upsellBusy) {
            console.log('[Upsell] Add already in progress, ignoring duplicate trigger');
            return;
          }
          form.__upsellBusy = true;
          if (addBtn) addBtn.disabled = true;

          try {
            await handleAdd();
          } finally {
            form.__upsellBusy = false;
            if (addBtn) addBtn.disabled = false;
          }
        };

        async function handleAdd() {
          const mainId = getMainVariantId(form);
          const qty = getQty(form);
          if (!mainId) { 
            console.warn('[Upsell] No main variant ID found');
            form.submit(); 
            return; 
          }

          const items = [{ id: Number(mainId), quantity: qty }];

          const val = selectedUpsellValue(card);
          const vid = resolveVariantId(card, val);
          if (vid) {
            items.push({ id: Number(vid), quantity: 1 });
            console.log('[Upsell] Adding upsell product:', vid);
          } else {
            console.warn('[Upsell] enabled but no variant match for', val);
          }

          try {
            console.log('[Upsell] Using simplified approach with theme integration');
            
            const mainId = getMainVariantId(form);
            const qty = getQty(form);
            if (!mainId) { 
              console.warn('[Upsell] No main variant ID found');
              form.submit(); 
              return; 
            }

            const items = [{ id: Number(mainId), quantity: qty }];

            const val = selectedUpsellValue(card);
            const vid = resolveVariantId(card, val);
            if (vid) {
              items.push({ id: Number(vid), quantity: 1 });
              console.log('[Upsell] Adding upsell product:', vid);
            } else {
              console.warn('[Upsell] enabled but no variant match for', val);
            }

            console.log('[Upsell] Adding items using theme system:', items);
            
            // Option 1: Try using your theme's addToCart function directly
            if (typeof window.addToCart === 'function') {
              console.log('[Upsell] Using theme addToCart function');
              window.addToCart(items);
              openCartDrawer();
              return;
            }
            
            // Option 2: Simulate form submission with multiple items
            const formData = new FormData();
            items.forEach((item, index) => {
              formData.append(`items[${index}][id]`, item.id);
              formData.append(`items[${index}][quantity]`, item.quantity);
            });
            
            // Add sections that your theme expects
            const cartDrawerElement = document.querySelector('cart-drawer');
            if (cartDrawerElement && cartDrawerElement.getSectionsToRender) {
              const sections = cartDrawerElement.getSectionsToRender().map(s => s.id);
              formData.append('sections', sections.join(','));
            } else {
              formData.append('sections', 'cart-drawer');
            }
            
            formData.append('sections_url', window.location.pathname);

            const response = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            });

            if (response.ok) {
              const data = await response.json();
              console.log('[Upsell] Theme-compatible add successful:', data);
              
              // Trigger your theme's cart refresh
              if (data.sections && data.sections['cart-drawer']) {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && cartDrawer.render) {
                  cartDrawer.render(data.sections['cart-drawer'], 'cart-drawer');
                }
              }
              
              // Trigger free gift check if it exists
              if (typeof window.checkFreeGift === 'function') {
                window.checkFreeGift(data);
              }
              
              openCartDrawer();
            } else {
              throw new Error('Add to cart failed');
            }

          } catch (e) {
            console.error('[Upsell] Theme-integrated add failed, falling back to native submit', e);
            form.submit();
          }
        };

        // Bind to both form submit and button click with capture
        form.addEventListener('submit', handler, true);
        if (addBtn) {
          addBtn.addEventListener('click', handler, true);
        }

        form._upsellBound = true;
      });
    }

    // Initialize everything
    function init() {
      console.log('[Upsell] Initializing...');
      bindUpsellLogic();
    }

    // Run on various lifecycle events
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    
    // Re-bind on Shopify section reloads
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', init);
    document.addEventListener('shopify:section:select', init);
    document.addEventListener('shopify:section:deselect', init);
    document.addEventListener('variant:change', init);
})();